import React from 'react';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from 'react-bootstrap';

interface DraftRecoveryDialogProps {
  onRecover: () => void;
  onDiscard: () => void;
}

export const DraftRecoveryDialog: React.FC<DraftRecoveryDialogProps> = ({
  onRecover,
  onDiscard
}) => {
  return (
    <Window
      title={'Unsaved local changes'}
      draggable={false}
      modal={true}
      resizable={false}
      minimizeButton={undefined}
      maximizeButton={undefined}
      initialWidth={500}
      initialHeight={300}
      onClose={onDiscard}>
      <div>
        <span>
          It looks like you have unsaved local changes that are newer than the
          latest version on the server.
        </span>
        <p className={'mt-2'}>
          Would you like to recover your last local draft or discard it and load
          the server version?
        </p>
      </div>
      <WindowActionsBar>
        <Button variant={'outline-secondary'} onClick={onDiscard}>
          Discard and Load Server
        </Button>
        <Button variant={'primary'} onClick={onRecover}>
          Recover Local Draft
        </Button>
      </WindowActionsBar>
    </Window>
  );
};

export default DraftRecoveryDialog;
